import React, { useContext, useState } from "react";
import noteContext from "../context/notes/noteContext";
import ConfirmModal from "./confirmModal";

const NoteItem = (props) => {
  const { note, updateNote, showAlert } = props;
  const context = useContext(noteContext);
  const { deleteNote } = context;
  const [showModal, setShowModal] = useState(false);

  // Handle actual deletion after confirmation
  const handleDelete = () => {
    deleteNote(note._id);
    showAlert({
      type: "error",
      title: "Delete:",
      message: "Note deleted successfully.",
    });
    setShowModal(false);
  };

  const formattedDate = new Date(note.date).toLocaleString();

  const DeleteIcon = () => (
    <svg
      style={{ height: "16px", width: "16px" }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 6h18"></path>
      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
      <path d="M8 6V4c0-1 1-2 2-2h4c0 1 1 2 2 2v2"></path>
    </svg>
  );

  const EditIcon = () => (
    <svg
      style={{ height: "16px", width: "16px" }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7 7h-1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1"></path>
      <path d="M20.385 6.585a2.1 2.1 0 0 0-2.97-2.97L9 12v3h3l8.385-8.415z"></path>
      <path d="m16 5 3 3"></path>
    </svg>
  );

  return (
    <>
      <div className="col-md-3">
        <div
          className="my-3"
          style={{
            backgroundColor: "white",
            borderRadius: "12px",
            padding: "20px",
            border: "1px solid rgb(229, 231, 235)",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px",
            transition: "transform 0.2s, box-shadow 0.2s",
            cursor: "pointer",
            transform: "translateY(0px) scale(1.02)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "180px",
            width: "400px",
            position: "relative",
            boxSizing: "border-box",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow =
              "0 4px 6px -1px rgba(0, 0, 0, 0.1)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 1px 3px 0 rgba(0, 0, 0, 0.1)";
          }}
        >
          {/* Tag */}
          <span
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              backgroundColor: "#fde68a",
              color: "#92400e",
              borderRadius: "8px",
              padding: "1.5px 5px",
              fontSize: "9px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              zIndex: 1,
            }}
          >
            {note.tag}
          </span>
          {/* Title */}
          <h3
            style={{
              fontSize: "16px",
              fontWeight: 600,
              color: "rgb(17, 24, 39)",
              lineHeight: 1.4,
              margin: 0,
              wordBreak: "break-word",
            }}
          >
            {note.title}
          </h3>

          {/* Description */}
          <p
            style={{
              fontSize: "14px",
              color: "rgb(107, 114, 128)",
              margin: "12px 0 0 0",
              padding: 0,
              flexGrow: 1,
              overflowY: "auto",
              textAlign: "left",
              wordBreak: "break-word",
            }}
          >
            {note.description}
          </p>

          {/* Action Icons */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "12px",
              gap: "5px",
            }}
          >
            <span style={{ fontSize: "12px", color: "#777" }}>
              Created on: {formattedDate}
            </span>

            {/* Delete Button */}
            <div>
              <button
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  padding: "4px",
                  borderRadius: "4px",
                  color: "#ef4444",
                  transition: "backgroundColor 0.2s",
                }}
                onClick={() => setShowModal(true)}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "#fef2f2")
                }
                onMouseOut={(e) =>
                  (e.target.style.backgroundColor = "transparent")
                }
              >
                <DeleteIcon />
              </button>

              {/* Confirm Modal */}
              <ConfirmModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                handleConfirm={handleDelete}
              />

              {/* Edit Button */}
              <button
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  padding: "4px",
                  borderRadius: "4px",
                  color: "grey",
                  transition: "backgroundColor 0.2s",
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "#f3f4f6")
                }
                onMouseOut={(e) =>
                  (e.target.style.backgroundColor = "transparent")
                }
                onClick={() => updateNote(note)}
              >
                <EditIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoteItem;
